import { Badge, type SelectOption } from '@synqo/frontend-component-library';
import { useNotificationsCount } from '@Contexts/notificationsCount';
import { useHasPermission } from '@Contexts/appContext';
import { useFeatureFlags } from '@Contexts/featureFlags';
import { Permission } from '@Constants/Permission.g';
import { useMemo } from 'react';

export type UseOrderTableModes = 'main' | 'staging';

export const useOrderTableModes = (): SelectOption<UseOrderTableModes>[] => {
    const { stagedOrders } = useNotificationsCount();
    const hasPermission = useHasPermission();
    const { isFeatureEnabled } = useFeatureFlags();
    const canCreateOrders = hasPermission(Permission.AuftragsbearbeitungOrdersCreate);
    const isStagingEnabled = isFeatureEnabled('STAGING');

    return useMemo(() => {
        const modes: SelectOption<UseOrderTableModes>[] = [
            {
                name: 'main',
                value: 'main',
                label: 'Aufträge',
            },
        ];

        if (canCreateOrders && isStagingEnabled) {
            modes.push({
                name: 'staging',
                value: 'staging',
                label: 'Auftragseingang',
                suffix:
                    stagedOrders > 0 ? (
                        <Badge variant="info" size="xxs" type="counter">
                            {stagedOrders}
                        </Badge>
                    ) : undefined,
            });
        }

        return modes;
    }, [stagedOrders, canCreateOrders, isStagingEnabled]);
};
